module.exports = __webpack_public_path__ + "img/producto.40522f85.png";